import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { FutureInfoService } from '../../../_services/index';
import {Http} from '@angular/http';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { AuthenticationService } from '../../../_services/index';

@Component({
  selector: 'app-future-college-plans',
  templateUrl: './future-college-plans.component.html',
  styleUrls: ['./future-college-plans.component.css'],
  providers: [FutureInfoService]
})
export class FutureCollegePlansComponent implements OnInit, OnDestroy {

  public validYear = [/[1-9]/, /\d/, /\d/, /\d/];
  futureClgForm: FormGroup;
  formChangeSub: Subscription;
  getdataSub: Subscription;
  submitdataSub: Subscription;
  postSecondarySub: Subscription;
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors: any;
  hideHowManyYears: boolean;
  isRequired: boolean;
  public personalEmail: string;
  currentUser: any;
  loading: boolean;
  public checkChange: boolean;
  public valueChange = false;
  public canDeactivateCheck = false;
  public checkingSubmit = false;
  postSecondaryData: any;
  public showother  = false;
  highschoolId;
  isCNIC = false;
  financialYear;
  currentYear;
  nextYear;

  constructor(private _fb: FormBuilder,
  private router: Router,
  public api: FutureInfoService,private loginservice: AuthenticationService,
) { }

  ngOnInit() {
    this.getFinancialYear();
    this.createForm();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.personalEmail = this.currentUser ? this.currentUser.email : '';
    this.futureClgForm.get('personalEmail').setValue(this.personalEmail);
    
    window.scrollTo(300, 500);
    this.checkCinc();
  }

  ngOnDestroy() {
    if (this.formChangeSub) {
      this.formChangeSub.unsubscribe();
    }
    if (this.getdataSub)  {
      this.getdataSub.unsubscribe();
    }
    if (this.submitdataSub)  {
      this.submitdataSub.unsubscribe();
    }
    if (this.postSecondarySub)  {
      this.postSecondarySub.unsubscribe();
    }
  }

  createForm()  {
    this.futureClgForm  = this._fb.group({
      gradeLevel: ['Freshman', [Validators.required]],
      institutionName: ['', [Validators.required]],
      topChoice: [''],
      collegeType: ['', [Validators.required]],
      anticipateGraduationYear: ['', [Validators.required]],
      diplomaType: [''],
      personalEmail: ['', [Validators.required]],
      educationGoal: ['', [Validators.required]],
      applyingfor:[''],
      enrollmentstatus:['']
    });

    this.formChangeSub = this.futureClgForm
    .valueChanges
    .subscribe(data => this._onValueChanged());
    this._onValueChanged();

  }

  onSubmit()  {

    const institutionNameVal = this.futureClgForm.controls.institutionName.value;
    let institutionName;
    if (typeof institutionNameVal === 'object') {
      institutionName = this.futureClgForm.controls.institutionName.value.id;
    } else {
      institutionName = this.highschoolId;

    }
    const body = JSON.stringify({
      gradeLevel: this.futureClgForm.controls.gradeLevel.value,
      topChoice: this.futureClgForm.controls.topChoice.value,
      institutionName: institutionName,
      collegeType: this.futureClgForm.controls.collegeType.value,
      anticipateGraduationYear: this.futureClgForm.controls.anticipateGraduationYear.value,
      diplomaType: this.futureClgForm.controls.diplomaType.value,
      educationGoal: this.futureClgForm.controls.educationGoal.value,
      personalEmail: this.futureClgForm.controls.personalEmail.value,
      applyingfor: this.futureClgForm.controls.applyingfor.value,
      enrollmentstatus: this.futureClgForm.controls.enrollmentstatus.value
    });
    this.submitting = true;
    this.api.postFutureInfo$(body)
      .subscribe(
        data => {
          this.error = false;
          this.submitting = false;
          const response = data;
            this.errorFlag = false;
            this.successMessage = response.message;
            if (!this.canDeactivateCheck) {
              this.checkingSubmit = true;
              this.router.navigate(['/profile/academic-career-goals']);
            }
        },
        error => {
          this.submitting = false;
          this.errorFlag = true;
          const errordata = JSON.parse(error._body);
          if (errordata.success === 0) {
            this.errorMessage = errordata.message;
            this.errorFlag = true;
            this.fieldErrors = errordata.errors;
          }
        },
      );
  }

  getFutureInfo() {
    this.loading = true;
    const body = JSON.stringify({
          email: this.personalEmail
    });

    this.getdataSub = this.api.getFutureInfo(body)
    .subscribe(responsedata => {
      const priorInfodata = responsedata.data;
      this.futureClgForm.controls['gradeLevel'].setValue(priorInfodata.grade_level);
      this.futureClgForm.controls['topChoice'].setValue(priorInfodata.top_choice);
      this.futureClgForm.controls['collegeType'].setValue(priorInfodata.college_type);
      this.futureClgForm.controls['anticipateGraduationYear'].setValue(priorInfodata.anticipate_graduation_year);
      this.futureClgForm.controls['diplomaType'].setValue(priorInfodata.diploma_type);
      this.futureClgForm.controls['educationGoal'].setValue(priorInfodata.education_goal);
      if (priorInfodata.institution_name) {
        this.highschoolId = JSON.parse(priorInfodata.institution_name).id;
        this.futureClgForm.controls['institutionName'].setValue(JSON.parse(priorInfodata.institution_name).name);

        setTimeout(() => {
          this.checkChange = true;
          this.loading = false;
        }, 2000);

      }
      console.log(priorInfodata.applyingfor);
      if (priorInfodata.applyingfor) {
        this.futureClgForm.controls['applyingfor'].setValue(priorInfodata.applyingfor);
      }

      if (priorInfodata.enrollmentstatus) {
        this.futureClgForm.controls['enrollmentstatus'].setValue(priorInfodata.enrollmentstatus);
      }

    });
  }

  private _onValueChanged() {
    if (this.checkChange) {
      this.valueChange = true;

    }
  }

  canDeactivate() {
    if (this.valueChange  && this.checkingSubmit === false ) {
      if (confirm('Do you want to save changes?')) {
        this.canDeactivateCheck = true;
        this.onSubmit();
      }
    }
    return true;
  }

  postSecondarysList() {
    this.loading = true;
    this.postSecondarySub =  this.api.postSecondarysList()
    .subscribe(responseData => {
      if ( responseData.status === 1) {
          this.postSecondaryData = responseData.data.postsecondaryinstitutes;
      }
      this.getFutureInfo();
      this.loading = false;
    });
  }

  renderHero = (data: any): SafeHtml => {
    const html = `<span>${data.name}</span>`;
    return html;
  }

  checkCinc(){
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    //const countLength = parts.length;
    const subdomain = parts.shift();
    console.log(subdomain);
    if(subdomain == 'cinc'){
        this.isCNIC = true;
    }
    else{
        this.isCNIC = false;
    }
  }

  getFinancialYear(){

    this.loginservice.getFinancialYear()
    .subscribe(responseData => {
        this.financialYear = responseData.financial_year;
        console.log(this.financialYear);
        let splits = this.financialYear.split('-');
        //console.log(splits);
        this.currentYear = splits[0];
        this.nextYear = splits[1];
        this.getFutureInfo();
    });

  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/future-college-plans/future-college-plans.component.ts